import { useTraderTagData } from './useTraderTagData';

/**
 * Labels ("High volume", "Insider", …) for a set of accounts. Keyed on the
 * sorted addresses, not the Set: callers pass a fresh but equal Set every render.
 * The reasons behind Data Error come from useTraderTagData.
 */
export function useTraderTags(addresses: Set<string>): Map<string, string[]> {
    return useTraderTagData(addresses).tags;
}
